import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { DegreeListingPage } from './pages/DegreeListingPage';
import { ExpandedFormPage } from './pages/ExpandedFormPage';
import { ResultsPage } from './pages/ResultsPage';
import { UniversityPage } from './pages/UniversityPage';
import { UMALandingPage } from './pages/UMALandingPage';
import { GTCLandingPage } from './pages/GTCLandingPage';
import { UAGCLandingPage } from './pages/UAGCLandingPage';
import { CollegesPage } from './pages/CollegesPage';
import { ThankYouPage } from './pages/ThankYouPage';
function AppContent() {
  const location = useLocation();
  // Hide global header on individual college pages (e.g. /colleges/global-tech-college or /colleges/global-tech-college/program)
  const isCollegeDetailPage = /^\/colleges\/[^/]+/.test(location.pathname) && location.pathname !== '/colleges';
  const isThankYouPage = location.pathname === '/thank-you';
  const hideChrome = isCollegeDetailPage || isThankYouPage;
  return <div className="min-h-screen flex flex-col font-sans" data-id="element-0">
      {!hideChrome && <Header data-id="element-1" />}
      <Routes data-id="element-2">
        <Route path="/" element={<HomePage data-id="element-4" />} data-id="element-3" />
        <Route path="/form" element={<ExpandedFormPage data-id="element-6" />} data-id="element-5" />
        <Route path="/degree/:areaStudy/:program" element={<HomePage data-id="element-8" />} data-id="element-7" />
        <Route path="/degrees/:category" element={<DegreeListingPage data-id="element-10" />} data-id="element-9" />
        <Route path="/colleges" element={<CollegesPage data-id="element-12" />} data-id="element-11" />
        <Route path="/colleges/ultimate-medical-academy" element={<UMALandingPage data-id="element-14" />} data-id="element-13" />
        <Route path="/colleges/global-tech-college" element={<GTCLandingPage data-id="element-16" />} data-id="element-15" />
        <Route path="/colleges/university-of-arizona-global-campus" element={<UAGCLandingPage data-id="element-18" />} data-id="element-17" />
        <Route path="/colleges/:universitySlug" element={<UniversityPage data-id="element-20" />} data-id="element-19" />
        <Route path="/colleges/:universitySlug/:programSlug" element={<UniversityPage data-id="element-22" />} data-id="element-21" />
        <Route path="/results" element={<ResultsPage data-id="element-24" />} data-id="element-23" />
        <Route path="/thank-you" element={<ThankYouPage data-id="element-26" />} data-id="element-25" />
        <Route path="*" element={<HomePage data-id="element-28" />} data-id="element-27" />
      </Routes>
      {!hideChrome && <Footer data-id="element-29" />}
    </div>;
}
export function App() {
  return <Router data-id="element-30">
      <AppContent data-id="element-31" />
    </Router>;
}